import { render, staticRenderFns } from "./TagsInput.vue?vue&type=template&id=6f378134&scoped=true&"
import script from "./TagsInput.vue?vue&type=script&lang=ts&"
export * from "./TagsInput.vue?vue&type=script&lang=ts&"
import style0 from "./TagsInput.vue?vue&type=style&index=0&id=6f378134&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f378134",
  null
  
)

export default component.exports